import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <header className="bg-white/80 backdrop-blur-xl border-b border-[#E2DDD8] sticky top-0 z-50">
        <div className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-4 flex items-center gap-4">
          <Link to="/login" className="text-[#1BB594] hover:underline">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-baseline gap-1.5">
            <img src="/arpai_logo.png" alt="ARPAI" style={{height: '1.25rem'}} />
            <span className="text-xl font-bold text-[#2F2E2F] tracking-[0.15em]">GEO</span>
          </div>
        </div>
      </header>

      <main className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-16">
        <h1 className="text-3xl sm:text-4xl tracking-tight font-black text-[#2F2E2F] mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-slate max-w-none text-sm leading-relaxed text-slate-700 space-y-6">
          <p className="text-xs text-slate-400 italic">Published: June 2026. This document is subject to updates.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">1. General Provisions</h2>
          <p>This Privacy Policy (hereinafter — the Policy) defines the procedures for processing and protecting personal data of users of the ARPAI GEO service (hereinafter — the Service), located at arpai-geo.com.</p>
          <p>The data controller is the owner of the Service (hereinafter — the Operator). Personal data processing is carried out in accordance with applicable data protection laws.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">2. Purposes of Data Processing</h2>
          <p>The Operator processes user personal data for the following purposes:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>User registration and identification in the Service;</li>
            <li>Providing access to Service functionality;</li>
            <li>Payment processing and billing management;</li>
            <li>Sending notifications related to Service usage;</li>
            <li>Improving Service quality and developing new features;</li>
            <li>Compliance with applicable legal requirements.</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">3. Categories of Data Collected</h2>
          <p>The Operator processes the following categories of personal data:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Email address;</li>
            <li>User name;</li>
            <li>Service usage data (operation history, balance);</li>
            <li>Technical data (IP address, browser user-agent).</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">4. Legal Basis for Processing</h2>
          <p>Personal data processing is carried out on the basis of:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>User consent to data processing;</li>
            <li>Performance of the Terms of Service agreement to which the User is a party.</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">5. User Rights</h2>
          <p>The User has the right to:</p>
          <ul className="list-disc ml-6 space-y-1">
            <li>Request information about the processing of their personal data;</li>
            <li>Request correction, restriction, or deletion of their data;</li>
            <li>Withdraw consent to personal data processing;</li>
            <li>Export their data (via the Data Export feature in the dashboard);</li>
            <li>Delete their account and all associated data.</li>
          </ul>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">6. Data Retention</h2>
          <p>Personal data is retained for the duration of the user account. Upon account deletion, all personal data is destroyed within 30 days, except for data required to be retained by applicable law.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">7. Data Protection</h2>
          <p>The Operator implements necessary organizational and technical measures to protect personal data from unauthorized access, destruction, modification, blocking, copying, distribution, and other unauthorized actions by third parties. Data is stored on secure servers with appropriate access controls.</p>

          <h2 className="text-lg font-bold text-[#2F2E2F] mt-8 mb-3">8. Contact Information</h2>
          <p>For questions regarding personal data processing, please contact: support@arpai-geo.com</p>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPage;
